/** Labeled wrapper for a single form control with an optional error message.
 *  Used by the auth forms (Login / Register). */
export function FormField({
  label,
  error,
  children,
}: {
  label: string;
  // `unknown`, not `string`: react-hook-form types `errors.x?.message` wider than a
  // plain string (FieldError | Merge<…>), so accept whatever it hands us and render
  // only when it's actually a string message.
  error?: unknown;
  children: React.ReactNode;
}) {
  const message = typeof error === 'string' ? error : undefined;
  return (
    <label className="field">
      <span className="field-label">{label}</span>
      <div>{children}</div>
      {message ? <span className="text-xs text-destructive mt-1 inline-block">{message}</span> : null}
    </label>
  );
}
